module.exports = __webpack_public_path__ + "static/media/mandd_3_sf.c53a4a2d.png";